import LabeledChip from '@components/v2/ui/LabeledChip/LabeledChip';
import { useScrollableTagsStyles } from './ScrollableTags.styles';
import { ScrollableTagsProps } from './ScrollableTags.types';

const ScrollableTags = ({ tags, variant }: ScrollableTagsProps) => {
  const { classes } = useScrollableTagsStyles();

  return (
    <div className={classes.scrollContainer}>
      <div className={classes.scrollContent}>
        {tags.map((tag) => (
          <LabeledChip key={tag.label} content={tag.label} appearance={variant} title={tag.label} />
        ))}
      </div>
    </div>
  );
};

export default ScrollableTags;
